import * as React from "react";
import * as Portal from "react-portal/build/portal";
import PositionAware from "modules/utilities/PositionAware";

const getLeftAlignStyles = ({top, height, left}) => ({
    top: window.pageYOffset + top + height,
    left,
    position: "absolute"
});

const getRightAlignStyles = ({top, height, right}) => ({
    top: window.pageYOffset + top + height,
    right: document.documentElement.clientWidth - right,
    position: "absolute"
});

const getCenterAlignStyles = ({top, height}) => ({
    top: window.pageYOffset + top + height,
    right: 0,
    left: 0,
    position: "absolute"
});

const getAlignStylesByAlignment = (align: "left" | "right" | "center", clientRect: ClientRect) => {
    if (align === 'left') {
        return getLeftAlignStyles(clientRect);
    } else if (align === 'right') {
        return getRightAlignStyles(clientRect);
    } else {
        return getCenterAlignStyles(clientRect);
    }
};

export default ({isOpen, content, children, align, className = ""}: any) =>
    <PositionAware>
        {(clientRect: ClientRect) => (
            <div style={{display: "inline-block"}}>
                {children}
                <Portal isOpened={isOpen}>
                    <div className={className} style={getAlignStylesByAlignment(align, clientRect)}>
                        {content}
                    </div>
                </Portal>
            </div>
        )}
    </PositionAware>



// WEBPACK FOOTER //
// ./resources/modules/cars/rating/tires/components/utils/Overlay.tsx